// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.op-form-switch{margin-bottom:1.1428571429rem}`, "",{"version":3,"sources":["webpack://./app/new-components/DLS/OpForm/formComponents/OpFormSwitch/OpFormSwitch.scss"],"names":[],"mappings":"AAEA,gBACE,6BAAA","sourcesContent":["@use 'assets/scss/common';\n\n.op-form-switch {\n  margin-bottom: common.toRem(16);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
